/**
 * Extracts specified properties from a source object.
 */
export const extractSelectedProperties = (source: Record<string, unknown>, properties: string[]): Record<string, unknown> => {
    const result: Record<string, unknown> = {};

    properties.forEach(property => {
        if (property in source) {
            result[property] = source[property];
        }
    });

    return result;
};

/**
 * Determine which stores are enabled for synchronization based on the provided configuration.
 */
export const getEnabledStoreIds = (config: Record<string, { enabled: boolean }>): string[] => {
    return Object.keys(config)
        .filter(id => config[id].enabled);
};
